import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button } from "antd";

export default function Page2() {
    const count = useSelector(state => state.app.count)
    const history = useHistory();
    const goto = () => {
        history.push('/page1');
    }
    return (
        <div>
            <Button onClick={goto}>go to Page1</Button>
            <p>{count}</p>
        </div>
    );
}
